<template>
  <div class="home_page" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang455') }}</span>
    </div>
    <!-- 热门抢购 -->
    <div class="goods_box" v-if="list.length > 0">
      <div class="goods_list" v-for="(item, index) in list" :key="index" @click="navigatorToPage('exDetail', item.id)">
        <van-image class="goods_list_img" radius="10" :src="item.thum" />
        <div class="right">
          <span class="ellipsis">{{ item.name }}</span>
          <div class="cen">
            <span class="money flex">
              {{ item.teac_price }}
              <span class="ssm">TeaC</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bare" v-else>
      <span>{{ $t('lang60') }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { homeApi } from '@/api/index';
import { Notify } from 'vant';
import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/lib/locale/lang/zh-CN';
export default {
  data() {
    return {
      showLoading: true,
      page: 1,
      list: [],
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getTeacExList();
    },
    //返回上一页
    back() {
      if (window.history.length <= 1) {
      // 如果没有历史记录，可以跳转到默认页
        this.$router.replace('/'); 
      } else {
        this.$router.back();
      }
    },
    navigatorTo(router) {
      if (this.$route.name == router) return;
      if (router != '') {
        this.$router.push({ name: router });
      } else {
        this.$toast(this.$t('lang2'));
      }
    },
    navigatorToPage(name, id, product_id) {
      this.$router.push({ name, query: { id: id, product_id: product_id } });
    },

    getTeacExList() {
      homeApi.getTeacExList({ page: this.page }).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          if (this.list.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data];
            console.log(this.list.length);
            if (this.list.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        console.log('Bottom');
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.getTeacExList(); // 触发加载更多
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.home_page {
  height: 100vh;
  overflow: auto;
  padding: 50px 0;

  .pd {
    padding: 14px;
    background-color: #fff;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cha {
      width: 100px;
    }

    .input {
      width: calc(100% - 110px);
      border: 1px solid #29b286;
      border-radius: 20px;
    }
    ::v-deep .van-field__control {
      padding: 6px 12px;
    }
    ::v-deep .van-icon-search {
      font-size: 20px;
      color: #29b286;
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .con {
    margin: 14px;
    border-radius: 12px;
    background-color: #fff;
  }

  .jsb {
    justify-content: space-between;
  }

  .goods_box {
    margin: 14px;
    border-radius: 14px;
    .good_icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }

  .goods_list {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    color: #000;
    padding: 12px;
    border-radius: 10px;
    // box-shadow: 0 4px 16px 0 rgba(53, 73, 93, 0.15);
    margin-bottom: 20px;
    // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    background-color: #fff;
    // background-image: linear-gradient(90deg, rgba(217, 239, 239, 0.3) 0, rgba(217, 239, 239, 0.3) 0, rgba(225, 240, 242, 0.3) 100%, rgba(225, 240, 242, 0.3) 100%);
    &_img {
      width: 80px;
      height: 80px;
      border-radius: 10px;
      margin-right: 10px;
    }

    .right {
      width: calc(100% - 90px);
      height: 65px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 13px;

      .time_text {
        color: #7f7f7f;
        font-weight: normal;
        font-size: 10px;
        text-decoration: line-through;
        // padding-top: 10px;
      }
      .cen1 {
        color: red;
        // font-weight: 550;
        // padding: 5px 0;
        font-size: 12px;
      }
      .cen {
        color: #29b286;
        // font-weight: 550;
        display: flex;
        align-items: center;
        // padding: 5px 0;
        font-size: 12px;
      }
      .money {
        font-size: 15px;
      }
      .ssm {
        font-size: 10px;
        font-weight: normal;
        padding-top: 2px;
      }
      .mon_t {
        color: #000;
        font-weight: normal;
      }
      .yel {
        font-weight: normal;
        white-space: nowrap;
        line-height: 100%;
        width: fit-content;
        // margin-left: 8px;
        padding: 0px 8px;
        border-radius: 16px;
        background-color: #f9f6e5;
        .count {
          color: #f7c35d;
          font-size: 9px;
        }
      }
      .green {
        width: fit-content;
        color: #29b286;
        background-color: #ddf2e7;
        font-size: 10px;
        font-weight: normal;
        padding: 2px 6px;
        border-radius: 6px;
      }
      .t2 {
        text-decoration: none;
      }

      .progress {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 10px;
        .pro {
          width: 70%;
          overflow: hidden;
        }
      }
    }
    .buy {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      &_btn {
        height: 26px;
        line-height: 26px;
        font-size: 10px;
        background-color: #29b286;
        border: none;
        padding: 0 10px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }
}


.flex {
  display: flex;
  align-items: center;
}

.ellipsis {
  // overflow: hidden; /* 确保超出容器的文本被裁剪 */
  // white-space: nowrap; /* 确保文本在一行内显示 */
  // text-overflow: ellipsis; /* 使用省略号表示文本超出 */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示的行数为2 */
  -webkit-box-orient: vertical;
  overflow: hidden; /* 隐藏溢出的文本 */
  text-overflow: ellipsis; /* 显示省略号 */
}
// ::v-deep .van-field__control {
//   overflow: hidden; /* 确保超出容器的文本被裁剪 */
//   white-space: nowrap; /* 确保文本在一行内显示 */
//   text-overflow: ellipsis; /* 使用省略号表示文本超出 */
// }
.bare {
  text-align: center;
  font-size: 14px;
  padding: 60px 14px;
  color: #888;
}
</style>